<template>
  <!-- Top line begins -->
  <div id="top">
    <div class="wrapper">
      <a href title class="logo">
        <img
          :src="`${$root.publicPath}images/icon/hs-logo-white-nomargin.png`"
          alt
          style="height: 30px;"
        />
      </a>

      <div
        style="color: white; line-height: 30px; margin-top: 10px; float: left; margin-left: 20px;"
      >{{ appVersion }}</div>

      <transition-group name="menu-fade" class="top_left_nav" tag="ul">
        <li
          :key="'vendor'"
          v-if="hasGroupPermission('vendor') && (!subMenuOpened || subMenuOpened === 'vendor')"
          @click="openSubMenu('vendor')"
        >
          <router-link
            tag="a"
            class="md-button"
            :to="{ name: 'vendor.index' }"
            :class="{'active': routeGroupIsActive('vendor')}"
          >
            <i class="fas fa-truck"></i>
            <span>Vendor</span>
          </router-link>
          <ul class="sub_nav" v-if="subMenuOpened === 'vendor'">
            <li v-if="hasGroupPermission('vendor')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'vendor.index' }"
                :class="{'active': routeGroupIsActive('vendor')}"
              >
                <span>Vendor List</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :key="'vendorproject'"
          v-if="(hasGroupPermission('vendorproject') || hasGroupPermission('project'))&& (!subMenuOpened || subMenuOpened === 'vendorproject')"
          @click="openSubMenu('vendorproject')"
        >
          <router-link
            tag="a"
            class="md-button"
            :to="{ name: 'vendorproject.index' }"
            :class="{'active': routeGroupIsActive('vendorproject') || routeGroupIsActive('project') || subMenuOpened === 'vendorproject'}"
          >
            <i class="fab fa-buffer"></i>
            <span>Vendor Project</span>
          </router-link>
          <ul class="sub_nav" v-if="subMenuOpened === 'vendorproject'">
            <li v-if="hasGroupPermission('vendorproject')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'vendorproject.index' }"
                :class="{'active': routeGroupIsActive('vendorproject')}"
              >
                <span>Vendor Project List</span>
              </router-link>
            </li>
            <li v-if="hasGroupPermission('project')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'project.index' }"
                :class="{'active': routeGroupIsActive('project')}"
              >
                <span>Project</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :key="'product'"
          v-if="(hasGroupPermission('product') || hasGroupPermission('product_category')) && (!subMenuOpened || subMenuOpened === 'product')"
          @click="openSubMenu('product')"
        >
          <router-link
            tag="a"
            class="md-button"
            :to="{ name: 'product.index' }"
            :class="{'active': routeGroupIsActive('product') || routeGroupIsActive('product.category') || subMenuOpened === 'product'}"
          >
            <i class="fas fa-glass"></i>
            <span>Product</span>
          </router-link>
          <ul class="sub_nav" v-if="subMenuOpened === 'product'">
            <li v-if="hasGroupPermission('product')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'product.index' }"
                :class="{'active': routeGroupIsActive('product')}"
              >
                <span>Product List</span>
              </router-link>
            </li>
            <li v-if="hasGroupPermission('product_category')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'product.category.index' }"
                :class="{'active': routeGroupIsActive('product.category')}"
              >
                <span>Product Categories</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :key="'samplestock'"
          v-if="hasGroupPermission('samplestock') && (!subMenuOpened || subMenuOpened === 'samplestock')"
          @click="openSubMenu('samplestock')"
        >
          <router-link
            tag="a"
            class="md-button"
            :to="{ name: 'samplestock.index' }"
            :class="{'active': routeGroupIsActive('samplestock')}"
          >
            <i class="fas fa-archive"></i>
            <span>Sample Stock</span>
          </router-link>
          <ul class="sub_nav" v-if="subMenuOpened === 'samplestock'">
            <li v-if="hasGroupPermission('samplestock')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'samplestock.index' }"
                :class="{'active': routeGroupIsActive('samplestock')}"
              >
                <span>Sample Stock List</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :key="'user'"
          v-if="(hasGroupPermission('user') || hasGroupPermission('role')) && (!subMenuOpened || subMenuOpened === 'user')"
          @click="openSubMenu('user')"
        >
          <router-link
            tag="a"
            class="md-button"
            :to="{ name: 'user.index' }"
            :class="{'active': routeGroupIsActive('user') || routeGroupIsActive('user.rolePermission') || subMenuOpened === 'user'}"
          >
            <i class="fas fa-users"></i>
            <span>User</span>
          </router-link>
          <ul
            class="sub_nav"
            v-if="subMenuOpened === 'user'"
          >
            <li v-if="hasGroupPermission('user')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'user.index' }"
                :class="{'active': routeGroupIsActive('user')}"
              >
                <span>User List</span>
              </router-link>
            </li>
            <li v-if="hasGroupPermission('role')">
              <router-link
                tag="a"
                class="md-button"
                :to="{ name: 'user.rolePermission.index' }"
                :class="{'active': routeGroupIsActive('user.rolePermission')}"
              >
                <span>Roles & Permissions</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li :key="'back'" @click="closeSubMenu()" v-if="subMenuOpened">
          <a class="md-button">
            <i class="fas fa-long-arrow-alt-left"></i>
          </a>
        </li>
      </transition-group>

      <!-- Right top nav -->
      <div class="topNav">
        <ul class="userNav">
          <li>
            <router-link tag="a" exact active-class="active" :to="{ name: 'changepassword' }">
              <i class="fas fa-unlock-alt"></i>
            </router-link>
          </li>
          <li>
            <a href="#" title class @click="doLogout()">
              <i class="fas fa-sign-out-alt"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Top line ends -->
</template>
<script>
export default {
  name: 'Top',
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      linksGroup: [
        'product', 'vendor', 'vendorproject', 'user', 'samplestock', 'user.rolePermission'
      ],
      subMenuOpened: false,
    }
  },
  props: {
    authUserData: Object,
    config: Object,
  },
  methods: {
    routeGroupIsActive(input) {
      return this.$route.name.startsWith(input + '.index') || this.$route.name.startsWith(input + '.create') || this.$route.name.startsWith(input + '.update') || this.$route.name.startsWith(input + '.view')
    },
    IsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        let reg = new RegExp('/system/' + path + '(/|$|#)', 'g');
        return this.$route.path.match(reg); // current path starts with this path string
      });
    },
    openSubMenu(section) {
      this.subMenuOpened = section
    },
    closeSubMenu() {
      this.subMenuOpened = false
    }
  },
  computed: {
    hasActive: function () {
      return this.linksGroup.some(element => {
        return this.subIsActive(element)
      })
    }
  },
}
</script>
<style scoped>
.userNav li {
  color: #dedcdc;
  text-align: center;
}
.userNav li a {
  color: #dedcdc !important;
  line-height: 28px;
}

/* # Top part
================================================== */

#top { background: url('../../assets/images/backgrounds/top.jpg') repeat-x 0 0; height: 50px; display: block; width: 100%; position: absolute; z-index: 10000; border-bottom: 1px solid #777; }
.logo { float: left; margin-top: 10px; }
.topNav { float: right; position: relative; }
.top_left_nav { float: left; margin: 0; padding: 0; margin-left: 10px; border-left: 1px solid #666; list-style: none; }
.top_left_nav { line-height: 48px; height: 48px; }
.top_left_nav li { color: white; float: left; }
.top_left_nav li a.md-button { color: #ccc !important; line-height: 49px; height: 49px; margin: 0; border-right: 1px solid #666; background: rgba(0,0,0, 0.3); text-align: center; padding: 0 18px; text-decoration: none; text-transform: none; font-size: 12px; }
.top_left_nav li a.md-button i { margin-right: 5px; }
.top_left_nav li a.md-button.active { background: #475f7d; border-right: 3px solid #000; }
.top_left_nav li a { float: left; }
.top_left_nav li .sub_nav { float: left; }


/*=== User navigation ===*/

#sidebar ul.userNav { display: none; }
ul.userNav { float: left; margin: 10px 0 0 0; }
ul.userNav li { display: inline-block; margin: 0 0 0 10px; background: #262626; -webkit-border-radius: 50%; -moz-border-radius: 50%; border-radius: 50%; box-shadow: 0 1px 0 #4e4e4e; -webkit-box-shadow: 0 1px 0 #4e4e4e; -moz-box-shadow: 0 1px 0 #4e4e4e }
ul.userNav li:hover { background-color: #282828; }
ul.userNav li:active { background-color: #242424; }
ul.userNav li a { display: block; height: 28px; width: 28px; }

ul.userNav li a.screen { background: url('../../assets/images/icons/usernav/screen.png') no-repeat 9px 9px; }
ul.userNav li a.settings { background: url('../../assets/images/icons/usernav/settings.png') no-repeat 9px 9px; }
ul.userNav li a.profile { background: url('../../assets/images/icons/usernav/profile.png') no-repeat 9px 9px;  }
ul.userNav li a.messages { background: url('../../assets/images/icons/usernav/messages.png') no-repeat 9px 10px;  }
ul.userNav li a.logout { background: url('../../assets/images/icons/usernav/logout.png') no-repeat 9px 9px; }
ul.userNav li a.search { background: url('../../assets/images/icons/usernav/search.png') no-repeat 9px 9px; }
ul.userNav li a.sidebar { background: url('../../assets/images/icons/usernav/sidebar.png') no-repeat 9px 9px; }

</style>   